import React from 'react';
import './ClientInfoForm.css';

function ClientInfoForm({ clientInfo, setClientInfo }) {
  const handleChange = (e) => {
    const { name, value } = e.target;
    setClientInfo(prev => ({ ...prev, [name]: value }));
  };

  return (
    <form className="client-info-form" onSubmit={e => e.preventDefault()}>
      <label>
        Full Name *
        <input type="text" name="name" required value={clientInfo.name} onChange={handleChange} />
      </label>

      <label>
        Email Address *
        <input type="email" name="email" required value={clientInfo.email} onChange={handleChange} />
      </label>

      <label>
        Business Name
        <input type="text" name="business" value={clientInfo.business} onChange={handleChange} />
      </label>

      <label>
        Project Goals
        <textarea name="goals" rows="3" value={clientInfo.goals} onChange={handleChange} />
      </label>

      <label>
        Preferred Timeline
        <select name="timeline" value={clientInfo.timeline} onChange={handleChange}>
          <option value="">Select</option>
          <option value="ASAP">ASAP</option>
          <option value="2–4 weeks">2–4 weeks</option>
          <option value="Flexible">Flexible</option>
        </select>
      </label>
    </form>
  );
}

export default ClientInfoForm;
